import { render, staticRenderFns } from "./ChatSpace.vue?vue&type=template&id=05306184&scoped=true"
import script from "./ChatSpace.vue?vue&type=script&lang=ts"
export * from "./ChatSpace.vue?vue&type=script&lang=ts"
import style0 from "./ChatSpace.vue?vue&type=style&index=0&id=05306184&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05306184",
  null
  
)

export default component.exports